import type { IUserAdmin, IUserPublic } from '~/types/user'

import config from '~/config'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'
import { request } from '~/utils/request'

export const getUserAsAdmin = (id: string): Promise<IUserAdmin> => {
  return request({
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${id}`,
  })
}

export const getUsersAsAdmin = (): Promise<IPaginatedResponse<IUserAdmin>> => {
  return request({
    params: { size: DEFAULT_ITEMS_PER_PAGE_VALUE },
    url: `${config.ADMIN_AUTHORIZATION_API}/user/search`,
  })
}

export const createUsers = (users: { email: string; name: string }[]): Promise<IUserPublic[]> => {
  return request({
    data: users,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/user`,
  })
}

export const updateUserEmail = ({ email, userId }: { email: string; userId: string }): Promise<IUserPublic> => {
  return request({
    data: { email },
    method: 'PUT',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/email`,
  })
}

export const updateUserName = ({ name, userId }: { name: string; userId: string }): Promise<IUserPublic> => {
  return request({
    data: {
      name,
    },
    method: 'PUT',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/name`,
  })
}

export const archiveUser = ({ id }: { id: string }): Promise<void> => {
  return request({
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${id}/block`,
  })
}

export const unarchiveUser = ({ id }: { id: string }): Promise<void> => {
  return request({
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${id}/unblock`,
  })
}

/*******************
 * User groups
 *******************/

export const addGroups = ({ groupIds, userId }: { groupIds: string[]; userId: string }): Promise<IUserAdmin> => {
  return request({
    data: groupIds,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/group`,
  })
}

export const deleteGroups = ({ groupIds, userId }: { groupIds: string[]; userId: string }): Promise<IUserAdmin> => {
  return request({
    data: groupIds,
    method: 'DELETE',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/group`,
  })
}

/*******************
 * User roles
 *******************/

export const addRoles = ({ roleIds, userId }: { roleIds: string[]; userId: string }): Promise<IUserAdmin> => {
  return request({
    data: roleIds,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/role`,
  })
}

export const deleteRoles = ({ roleIds, userId }: { roleIds: string[]; userId: string }): Promise<IUserAdmin> => {
  return request({
    data: roleIds,
    method: 'DELETE',
    url: `${config.ADMIN_AUTHORIZATION_API}/user/${userId}/role`,
  })
}
